<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <breadcrumb9></breadcrumb9>
    <!-- Page Content -->
    <div class="content">
      <div class="container">
        <!-- Doctor Widget -->
        <div class="card">
          <div class="card-body">
            <div class="doctor-widget">
              <div class="doc-info-left">
                <div class="doctor_img mr-5">
                  <img :src="loadImg(doctor.image)" class="img-fluid ml-5" alt="User Image"
                    style="width: 150px;height: 150px; border-radius: 5px;" />
                </div>
                <div class="doc-info-cont">
                  <h4 class="doc-name">
                    {{ doctor.first_name }} {{ doctor.middle_name }}
                    {{ doctor.last_name }}
                  </h4>
                  <p class="doc-speciality">
                    {{ doctor.healthcare_practitioner_category }}
                  </p>
                  <p style="font-size: 13px;" v-for="speciality in doctor.practitioner_speciality" :key="speciality.practitioner_speciality">Speciality : {{
                    speciality.practitioner_speciality }}
                  </p>
                  <p class="doc-department">
                    <span style="color:gray;font-size: 13px;">Qualification :</span> {{ qualification }}
                  </p>
                  <div class="rating d-flex" v-if="doctor.average_ranking">
                    <star-rating v-model="doctor.average_ranking" :star-size="20" :max-rating="5" :show-rating="false"
                      :read-only="disabledEdit"></star-rating>
                    <span class="d-inline-block average-rating mt-2 ml-1">({{ doctor.average_ranking }})</span>
                  </div>
                  <div class="clinic-details">
                    <p class="doc-location"> Address :&nbsp;
                      <i class="fas fa-map-marker-alt"></i>
                      {{ doctor.address }} {{ doctor.pincode }} <br />
                      <!-- <a href="javascript:void(0);">Get Directions</a> -->
                    </p>

                    <div class="row">
                      <div class="col-md-6 col-6" v-if="doctor.photo_1">
                        <a href="javascript:void(0);" data-fancybox="gallery">
                          <img :src="loadImg(doctor.photo_1)" alt="Feature" class="image_list" />
                        </a>
                      </div>
                      <div class="col-md-6 col-6" v-if="doctor.photo_2">
                        <a href="javascript:void(0);" data-fancybox="gallery">
                          <img :src="loadImg(doctor.photo_2)" alt="Feature Image" class="image_list" />
                        </a>
                      </div>
                      <div class="col-md-6 col-6 mt-md-2" v-if="doctor.photo_3">
                        <a href="javascript:void(0);" data-fancybox="gallery">
                          <img :src="loadImg(doctor.photo_3)" alt="Feature" class="image_list" />
                        </a>
                      </div>
                      <div class="col-md-6 col-6 mt-md-2" v-if="doctor.photo_4">
                        <a href="javascript:void(0);" data-fancybox="gallery">
                          <img :src="loadImg(doctor.photo_4)" alt="Feature" class="image_list" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="doc-info-right">
                <div class="clini-infos">
                  <ul>
                    <li v-if="doctor.feedback_count">
                      <i class="far fa-comment"></i>
                      {{ doctor.feedback_count }} Feedback
                    </li>
                    <li>
                      <i class="fas fa-map-marker-alt"></i> {{ doctor.city }},
                      {{ doctor.state }}
                    </li>
                  </ul>
                </div>
                <div class="doctor-action">
                  <a v-if="user_type === 'patient'" href="javascript:void(0)" @click="add_favourite_Doctor"
                    class="btn btn-white fav-btn mb-2">
                    <i class="fas fa-heart fa-heart"></i>
                  </a>
                  <a v-if="user_type === 'patient'" href="javascript:void(0)" @click="remove_favourite_Doctor"
                    class="btn btn-white fav-btnn mb-2">
                    <i class="fas fa-ban"></i>
                  </a>
                </div>

                <div class="clinic-booking">
                  <a v-if="doctor.booking_appoinment === 0" class="apt-btn mx-auto no-schedule"
                    style="background-color:#B0C4DE;border:none;">No Schedule</a>
                  <a v-else-if="doctor.booking_appoinment === 1" class="apt-btn mx-auto book-appointment"
                    @click="check_book_appointment(doctor.name)">Book Appointment</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Doctor Widget -->

        <!-- Doctor Details Tab -->
        <div class="card">
          <div class="card-body pt-0">
            <!-- Tab Menu -->
            <nav class="user-tabs mb-4">
              <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                <li class="nav-item mb-3">
                  <a class="nav-link active" href="#doc_overview" data-toggle="tab">Profile</a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link" href="#doc_locations" data-toggle="tab">Schedules</a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link" href="#doc_reviews" data-toggle="tab">Reviews</a>
                </li>
              </ul>
            </nav>
            <!-- /Tab Menu -->
            <!-- <h3 class="mb-3">Profile </h3> -->
            <!-- Tab Content -->
            <div class="tab-content pt-0">
              <!-- Overview Content -->
              <div role="tabpanel" id="doc_overview" class="tab-pane fade show active">
                <div class="row">
                  <div class="col-md-12 col-lg-9">
                    <!-- About Details -->
                    <div class="widget about-widget" v-if="doctor.about_me != null">
                      <!-- <h4 class="widget-title">About Me</h4> -->
                      <p>
                        {{ doctor.about_me }}
                      </p>
                    </div>
                    <!-- /About Details -->

                    <!-- Education Details -->
                    <div class="widget education-widget">
                      <h4 class="widget-title">Education</h4>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li v-for="(
                              qualification, index
                            ) in doctor.qualification" :key="index">
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  qualification.college
                                }}</a>
                                <div>{{ qualification.qualification }}</div>
                                <span class="time">{{ qualification.year_from }} -
                                  {{ qualification.year_to }}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- /Education Details -->

                    <!-- Experience Details -->
                    <div class="widget experience-widget">
                      <h4 class="widget-title">Work & Experience</h4>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li v-for="(experience, index) in doctor.experience" :key="index">
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  experience.hospital_clinic
                                }}</a>
                                <span class="time" v-if="experience.period_from != null &&
                                    experience.period_to != null
                                    ">{{ experience.period_from }} -
                                  {{ experience.period_to }}</span>
                                <span class="time" v-if="experience.role != null">{{ experience.role }}
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- /Experience Details -->

                    <!-- Awards Details -->
                    <div class="widget awards-widget" v-if="doctor.award_details != undefined">
                      <h4 class="widget-title">Awards</h4>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li v-for="(award, index) in doctor.award_details" :key="index">
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <h4 class="exp-title">{{ award.award }}</h4>
                                <p class="exp-year">{{ award.year }}</p>
                                <p>
                                  {{ award.awarder }}
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- /Awards Details -->

                    <!-- Services List -->
                    <div class="service-list" v-if="doctor.body_parts_treated != undefined">
                      <h4>Services</h4>
                      <ul class="clearfix">
                        <li v-for="(
                            body_parts_treated, index
                          ) in doctor.body_parts_treated" :key="index">
                          {{ body_parts_treated.body_parts_treated }}
                        </li>
                      </ul>
                    </div>
                    <!-- /Services List -->

                    <!-- Specializations List -->
                    <div class="service-list mt-5" v-if="doctor.area_of_practice != undefined">
                      <h4>Specializations</h4>
                      <ul class="clearfix">
                        <li  v-for="speciality in doctor.practitioner_speciality"
                      :key="speciality.practitioner_speciality">
                      {{ speciality.practitioner_speciality }}
                        </li>
                      </ul>
                    </div>
                    <!-- /Specializations List -->
                  </div>
                </div>
              </div>
              <!-- /Overview Content -->

              <!-- Locations Content -->
              <div role="tabpanel" id="doc_locations" class="tab-pane fade">
                <!-- Location List -->
                <div class="location-list" v-for="(item, index) in doctor_locations" v-bind:key="index">
                  <div class="row">
                    <!-- Clinic Content -->
                    <div class="col-md-6">
                      <div class="clinic-content">
                        <h4 class="clinic-name">
                          <a href="#">{{
                            item.hospital_details[0].name_of_hospital
                          }}</a>
                        </h4>
                        <p class="doc-speciality">
                          {{ item.hospital_details[0].hospital_tagline }}
                        </p>
                        <div class="clinic-details mb-0">
                          <h5 class="clinic-direction">
                            <i class="fas fa-map-marker-alt"></i>
                            {{
                              item.hospital_details[0].address
                              ? item.hospital_details[0].address
                              : ""
                            }}
                            {{
                              item.hospital_details[0].suburb
                              ? item.hospital_details[0].suburb
                              : ""
                            }}
                            {{
                              item.hospital_details[0].city
                              ? item.hospital_details[0].city
                              : ""
                            }}
                            {{
                              item.hospital_details[0].state
                              ? item.hospital_details[0].state
                              : ""
                            }}
                            {{
                              item.hospital_details[0].pincode
                              ? "-" + item.hospital_details[0].pincode
                              : ""
                            }}
                            <br />
                          </h5>

                          <div class="row">
                      <div class="col-md-3 col-6"  v-if="item.hospital_details[0].photo_1">
                        <a href="javascript:void(0);" data-fancybox="gallery2">
                                <img :src="loadImg(item.hospital_details[0].photo_1)
                                  " alt="Feature Image" class="image_list"/>
                              </a>
                      </div>
                      <div class="col-md-3 col-6" v-if="item.hospital_details[0].photo_2">
                        <a href="javascript:void(0);" data-fancybox="gallery2">
                                <img :src="loadImg(item.hospital_details[0].photo_2)
                                  " alt="Feature Image" class="image_list"/>
                              </a>
                      </div>
                      <div class="col-md-3 col-6" v-if="item.hospital_details[0].photo_3">
                        <a href="javascript:void(0);" data-fancybox="gallery2">
                                <img :src="loadImg(item.hospital_details[0].photo_3)
                                  " alt="Feature Image" class="image_list"/>
                              </a>
                      </div>
                      <div class="col-md-3 col-6" v-if="item.hospital_details[0].photo_4">
                        <a href="javascript:void(0);" data-fancybox="gallery2">
                                <img :src="loadImg(item.hospital_details[0].photo_4)
                                  " alt="Feature Image" class="image_list"/>
                              </a>
                      </div>
                    </div>

                        </div>
                      </div>
                    </div>
                    <!-- /Clinic Content -->

                    <!-- Clinic Timing -->
                    <div class="col-md-4">
                      <div class="clinic-timing">
                        <div v-for="(item, index) in item.schedule" v-bind:key="index">
                          <p class="timings-days">
                            <span> {{ item.day }} </span>
                          </p>
                          <p class="timings-times">
                            <span>{{ item.from_time.slice(0, 5) }} - {{ item.to_time.slice(0, 5) }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- /Clinic Timing -->

                    <div class="col-md-2">
                      <div class="consult-price">₹{{ item.fees }}</div>
                    </div>
                  </div>
                </div>
                <h5 v-if="doctor_locations.length === 0" style="margin-left: 3%; padding: 5%" class="No_data">
                  No Data Found
                </h5>
                <!-- /Location List -->
              </div>
              <!-- /Locations Content -->

              <!-- Reviews Content -->
              <div role="tabpanel" id="doc_reviews" class="tab-pane fade">
                <!-- Review Listing -->
                <div class="widget review-listing">
                  <ul class="comments-list">
                    <!-- Comment List -->
                    <li v-for="(item, index) in reviews" v-bind:key="index">
                      <div class="comment">
                        <img class="avatar rounded-circle" alt="User Image" v-bind:src="item.image
                          ? config.base_url_for_Image + item.image
                          : loadDemoImg('patient.jpg')
                          " />
                        <div class="comment-body">
                          <div class="meta-data">
                            <span class="comment-author">{{
                              item.user_name ? item.user_name : "-"
                            }}</span>
                            <span class="comment-date">Reviewed {{ formatDate(item.published_on) }}</span>
                            <div class="review-count rating">
                              <star-rating v-model="item.rating" :star-size="20" :max-rating="5" :show-rating="false"
                                :read-only="disabledEdit"></star-rating>
                            </div>
                          </div>
                          <p class="recommended">
                            <i class="far fa-thumbs-up"></i>
                            {{ item.review_title }}
                          </p>
                          <p class="comment-content">
                            {{ item.comment }}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <h5 v-if="reviews.length === 0" style="margin-left: 3%; padding: 5%" class="No_data">
                  No Reviews Found
                </h5>
                <!-- /Review Listing -->

                <!-- Write Review -->
                <div class="write-review" v-if="user_type">
                  <h4>
                    Write a review for
                    <strong>
                      {{ doctor.first_name }} {{ doctor.middle_name }}
                      {{ doctor.last_name }}</strong>
                  </h4>

                  <!-- Write Review Form -->
                  <!-- <form> -->
                  <div class="form-group">
                    <label>Review</label>
                    <star-rating :show-rating="false" v-model="add_review.rating" :star-size="20"
                      @rating-selected="setRating"></star-rating>
                  </div>
                  <div class="form-group">
                    <label>Title of your review</label>
                    <input v-model="add_review.review_title" class="form-control" type="text"
                      placeholder="If you could say it in one sentence, what would you say?" />
                  </div>
                  <div class="form-group">
                    <label>Your review</label>
                    <textarea v-model="add_review.comment" id="review_desc" maxlength="100"
                      class="form-control"></textarea>

                    <div class="d-flex justify-content-between mt-3">
                      <small class="text-muted"><span id="chars">100</span> characters remaining</small>
                    </div>
                  </div>
                  <hr />
                  <div class="submit-section text-left">
                    <button type="submit" @click="add_portal_review" class="btn btn-primary submit-btn">
                      Add Review
                    </button>
                  </div>
                  <!-- </form> -->
                  <!-- /Write Review Form -->
                </div>
                <!-- /Write Review -->
              </div>
              <!-- /Reviews Content -->

              <!-- Business Hours Content -->
              <div role="tabpanel" id="doc_business_hours" class="tab-pane fade">
                <div class="row">
                  <div class="col-md-6 offset-md-3">
                    <!-- Business Hours Widget -->
                    <div class="widget business-widget">
                      <div class="widget-content">
                        <div class="listing-hours">
                          <div class="listing-day current">
                            <div class="day">Today <span>5 Nov 2019</span></div>
                            <div class="time-items">
                              <span class="open-status"><span class="badge bg-success-light">Open Now</span></span>
                              <span class="time">07:00 AM - 09:00 PM</span>
                            </div>
                          </div>
                          <div class="listing-day">
                            <div class="day">Monday</div>
                            <div class="time-items">
                              <span class="time">07:00 AM - 09:00 PM</span>
                            </div>
                          </div>
                          <div class="listing-day">
                            <div class="day">Tuesday</div>
                            <div class="time-items">
                              <span class="time">07:00 AM - 09:00 PM</span>
                            </div>
                          </div>
                          <div class="listing-day">
                            <div class="day">Wednesday</div>
                            <div class="time-items">
                              <span class="time">07:00 AM - 09:00 PM</span>
                            </div>
                          </div>
                          <div class="listing-day">
                            <div class="day">Thursday</div>
                            <div class="time-items">
                              <span class="time">07:00 AM - 09:00 PM</span>
                            </div>
                          </div>
                          <div class="listing-day">
                            <div class="day">Friday</div>
                            <div class="time-items">
                              <span class="time">07:00 AM - 09:00 PM</span>
                            </div>
                          </div>
                          <div class="listing-day">
                            <div class="day">Saturday</div>
                            <div class="time-items">
                              <span class="time">07:00 AM - 09:00 PM</span>
                            </div>
                          </div>
                          <div class="listing-day closed">
                            <div class="day">Sunday</div>
                            <div class="time-items">
                              <span class="time"><span class="badge bg-danger-light">Closed</span></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Business Hours Widget -->
                  </div>
                </div>
              </div>
              <!-- /Business Hours Content -->
            </div>
          </div>
        </div>
        <!-- /Doctor Details Tab -->
      </div>
    </div>
    <!-- /Page Content -->
    <layout-footer></layout-footer>
  </div>
</template>
<script>
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
import StarRating from "vue-star-rating";
const images = require.context("@/assets/img/patients", false, /\.png$|\.jpg$/);
export default {
  data() {
    return {
      doctor: "",
      reviews: [],
      doctor_locations: [],
      disabledEdit: true,
      config: config,
      add_review: {
        doctor: this.$route.params.name,
        user: localStorage.getItem("userInfo")
          ? JSON.parse(localStorage.getItem("userInfo")).user
          : null,
        review_title: "",
        rating: 0,
        comment: "",
      },
      qualification: "",
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),
  },
  components: { StarRating },
  mounted() {
    this.get_doctor_profile();
    this.get_portal_review();
    this.get_doctor_location();
  },
  methods: {
    formatTime(time) {
      const date = new Date(time);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      // const year = date.getFullYear();
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`;
    },
    loadImg(imgPath) {
      return "https://app.bhilwarahealthcare.in" + imgPath;
    },

    get_doctor_qualification() {
      var qualification_string = [];
      this.doctor.qualification.map((data) => {
        qualification_string.push(data.qualification);
      });
      this.qualification = qualification_string.join(" , ");
    },

    setRating: function (rating) {
      this.add_review.rating = rating;
    },

    loadDemoImg(imgPath) {
      return images("./" + imgPath);
    },

    add_portal_review() {
      this.$swal({
        text: "Adding Your Review...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      CommonApi.post_data("sahaj.api.add_portal_review", this.add_review).then(
        (res) => {
          if (res && res.data.length !== 0 && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            (this.add_review.review_title = ""),
              (this.add_review.rating = 0),
              (this.add_review.comment = "");
            this.get_portal_review();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },

    async check_book_appointment(id) {
      this.$swal({
        text: "Checking Schedule...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const data = new URLSearchParams();
      data.append("practitioner", id);
      await CommonApi.get_data(
        "sahaj.appointment.check_practitioner_schedule",
        data
      ).then((res) => {
        if (res && res.status_code === 200) {
          this.$swal.close();
          this.$router.push({
            name: "booking",
            params: { name: id },
          });
        } else {
          this.$swal.close();
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async get_doctor_profile() {
      let search = new URLSearchParams({ name: this.$route.params.name });
      await CommonApi.get_data(
        "sahaj.finalapi.get_doctor_profile",
        search
      ).then((res) => {
        this.doctor = res.data[0];
        this.get_doctor_qualification();
        // console.log(this.doctor)
        if (res.data.length === 0) {
          this.$router.push("/");
        }
      });
    },

    /* Add Doctor As Favourite  */
    async add_favourite_Doctor(doctor) {
      this.$swal({
        text: "Adding Doctor As Favourite",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        practitioner: this.doctor.name,
        patient: this.user_id,
      };
      await CommonApi.post_data("sahaj.finalapi.favorite_doctor", data).then(
        (res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
          }
          else {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },


    /* Add Doctor As Favourite  */
    async add_favourite_Doctor_again() {
      let data = {
        practitioner: this.doctor.name,
        patient: this.user_id,
      };
      await CommonApi.post_data("sahaj.finalapi.favorite_doctor", data).then(
        (res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },

    /* Add Doctor As UnFavourite  */
    async remove_favourite_Doctor() {
      this.$swal({
        text: "Removing Doctor From Favourite",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        practitioner: this.doctor.name,
        patient: this.user_id,
      };
      await CommonApi.post_data("sahaj.finalapi.unfavorite_doctor", data).then(
        (res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },

    /* Get Doctor Reviews  */
    async get_portal_review() {
      const params = new URLSearchParams();
      params.append("doctor", this.$route.params.name);
      await CommonApi.get_data("sahaj.api.get_portal_review", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.data && res.status_code === 200) {
            this.reviews = res.data.map((item) => ({
              ...item,
              rating: item.rating * 5, // Multiply the rating by 5
            }));
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },

    /* Get Doctor Reviews  */
    async get_doctor_location() {
      const params = new URLSearchParams();
      params.append("healthcare_practitioner", this.$route.params.name);
      await CommonApi.get_data(
        "sahaj.finalapi.get_doctor_location_v2",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code == 200) {
          this.doctor_locations = res.data;
          console.log(res.data)
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },
  },
};
</script>

<style>
.image_list {
  width: 100px;
  height: 100px;
}

.apt-btn {
  width: 200px !important;
}

.book-appointment {
  cursor: pointer;
}

.clinic-service {
  color: #272b41;
}

.service-container {
  box-sizing: border-box;
  /* Two items per row */
  margin: 1px;
  display: inline-block;

}

.clinic-service span {
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  padding: 3px 3px;
  margin: 3px;
}
.fa-heart {
  color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Profile.vue